import { useState } from "preact/hooks";
import { setCustomer } from "../store";
import { ChatHeader } from "./ChatHeader";
import { trackChatLead } from "../tracking";

export function GateForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState<string | null>(null);

  const submit = (e: Event) => {
    e.preventDefault();
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    if (!trimmedName || !trimmedEmail) {
      setErr("Fyll inn både navn og e-post");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      setErr("Sjekk e-postadressen, den ser ikke helt riktig ut");
      return;
    }
    setCustomer(trimmedName, trimmedEmail);
    trackChatLead({ name: trimmedName, email: trimmedEmail });
  };

  return (
    <>
      <ChatHeader />
      <div class="ic-gate">
        <h3>Spør oss om badstu</h3>
        <p class="ic-lede">
          Modeller, priser, levering eller montering. Iskra svarer med en gang,
          og vi følger opp på e-post hvis det trengs.
        </p>
        <form onSubmit={submit} noValidate>
          <label class="ic-field">
            <span class="ic-field-label">Navn</span>
            <input
              type="text"
              autoComplete="name"
              placeholder="Fornavn"
              value={name}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
            />
          </label>
          <label class="ic-field">
            <span class="ic-field-label">E-post</span>
            <input
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="navn@eksempel.no"
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            />
          </label>
          {err && <p class="ic-err" role="alert">{err}</p>}
          <button class="ic-submit">Start samtalen</button>
          <p class="ic-fineprint">Vi bruker dette bare til å svare deg.</p>
        </form>
      </div>
    </>
  );
}
